import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import GAuth from 'vue-google-oauth2'
import VueMeta from 'vue-meta'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import routes from './routes';

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_AUTH_CLIENT_ID,
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.prototype.$baseApiUrl = process.env.VUE_APP_BASE_URL + '/'
Vue.prototype.$authenticated = { value: false, init: false };
Vue.use(GAuth, gauthOption)
Vue.use(VueAxios, axios);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueMeta, { refreshOnceOnNavigation: true })

Vue.config.productionTip = false;
Vue.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL + '/';


const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
  Vue.prototype.$http.get(process.env.VUE_APP_BASE_URL + '/' + 'auth').then(response => {
    if (response.data === 'authorized') {
      Vue.prototype.$authenticated.value = true;
      Vue.prototype.$authenticated.init = true;
    } else {
      Vue.prototype.$authenticated.init = true;
      localStorage.removeItem('token');
    }
  });
} else {
  Vue.prototype.$authenticated.init = true;
}


const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },  
  mode: 'history'
});

new Vue({
  render: h => h(App),
  router
}).$mount('#app');